import { Box } from '@mui/material';
import {AddIcon, QrCodeIcon} from '../../../../components/buttons/IconButtons';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import { permissionObj } from '../../../../Helpers/permission';
import routes from '../../../../Routes/routes';
import CreateVisitorModal from '../Modal/CreateVisitorModal';
import ButtonAction from './../../../../components/buttons/ButtonAction';
import HeadTittle from './../../../../components/HeadTittle';
import StepperTabs from './../../../../components/StepperTabs/StepperTabs';
import StepTab from './../../../../components/StepperTabs/StepTab';
import VisitorTab from './../Visitor/VisitorTab';
import { GuardMainApp } from './Functionality/GuardMainApp';
import RequestAccessModal from './Modal/RequestAccessModal';
import {handleDownloadQR, TAB_PERMISSION_GUARD, TABS_GUARD} from './Model/Model';
import RequestTab from './SubComponents/RequestTab';
import {MODELS} from "../../../../Apis/Models";

/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
const GuardMain = () => {
    const {
        t,
        dispatch,
        DEV,
        isGuard,
        permission,
        navigate,
        steps,
        activeStep,
        setActiveStep,
        setDeleteModal,
        deleteModal,
        selectedList,
        setSelectedList,
        search,
        setSearch,
        setCriteria,
        setBodyForExport,
        searchElement,
        setSearchElement,
        finalArray,
        setFinalArray,
        modified,
        setModified,
        setShowVisitorModal,
        handleStepChange,
        setShowCreateNewVisitorModal,
        showCreateNewVisitorModal,
        viewOrigin,
        view,
        setView,
        setShowRequestAccessModal,
        showRequestAccessModal,
        permissionButtons,
        handleCreateDelete,
        isAllChecked,
        setIsAllChecked,
        setSimpleSearch
    } = GuardMainApp();
    if (
        !DEV && !isGuard &&
        !permission?.includes(permissionObj?.WEB_VISITOR_READ)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'visitors'}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>
                    <ButtonAction
                        id='btn_gm_generate_qr'
                        name={'generate_qr'}
                        className='btn-icon-accent-450'
                        Icon={QrCodeIcon}
                        splitName={false}
                        onClick={() => handleDownloadQR(dispatch)}
                    />

                    {permissionButtons(TAB_PERMISSION_GUARD().CREATE) && (
                        <ButtonAction
                            id='btn_gm_add'
                            name={'create_new_visitor'}
                            className='btn-icon-add'
                            Icon={AddIcon}
                            splitName={false}
                            onClick={() => {
                                handleCreateDelete(ACTION_MODEL.CREATE);
                            }}
                        />
                    )}
                </Box>
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_GUARD.VISITORS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_GUARD.VISITORS.INDEX && (
                        <VisitorTab
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            setCriteria={setCriteria}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                            search={search}
                            setSearch={setSearch}
                            deleteModal={deleteModal}
                            setDeleteModal={setDeleteModal}
                            modified={modified}
                            setModified={setModified}
                            setShowVisitorModal={setShowVisitorModal}
                            setShowCreateNewVisitorModal={setShowCreateNewVisitorModal}
                            setShowRequestAccessModal={setShowRequestAccessModal}
                            viewOrigin={viewOrigin}
                            view={view}
                            setView={setView}
                            isAllChecked={isAllChecked}
                            setIsAllChecked={setIsAllChecked}
                            setSimpleSearch={setSimpleSearch}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_GUARD.REQUESTS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_GUARD.REQUESTS.INDEX && <RequestTab activeStep={activeStep}/>}
                </StepTab>
            </StepperTabs>
            <CreateVisitorModal
                title={t('create_visitor')}
                show={showCreateNewVisitorModal}
                onHide={() => setShowCreateNewVisitorModal(false)}
                modified={modified}
                setModified={setModified}
                moduleId={MODELS.GuardRoster}
            />
            <RequestAccessModal
                title={t('request_access')}
                show={showRequestAccessModal}
                onHide={() => setShowRequestAccessModal(false)}
                modified={modified}
                setModified={setModified}
                 selectedList={selectedList}
            />
        </>
    );
};

export default GuardMain;
